<template>
    <div class="login-container">
        <div class="login-top">
            <div class="login-top-bg">
                <div class="login-top-content">
                    <div class="live-name">{{channelInfo.title}}</div>
                    <div class="live-time">直播时间：{{channelInfo.begin_time}}</div>
                    <div class="login-main clearfix">
                        <div class="live-img">
                            <el-image class="live-img-src" :src="channelInfo.cover ? channelInfo.cover : 'https://chuangpei-prod.oss-cn-hangzhou.aliyuncs.com/images/png_fengmian%402x.png'"></el-image>
                        </div>
                        <div class="login-entrance">
                            <div class="login-entrance-title">登录</div>
                            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" auto-complete="on" label-position="left">
                                <el-form-item prop="username">
                                    <el-input v-model="loginForm.username" placeholder="请输入频道号" name="username" type="text" tabindex="1" auto-complete="on">
                                    <i slot="prefix" class="iconfont icon-icon_login_zhanghao"></i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <el-input :type="passwordType ? 'text' : 'password'"
                                    class="password"
                                    v-model="loginForm.password"
                                    placeholder="请输入密码"
                                    name="password"
                                    tabindex="2"
                                    auto-complete="on"
                                    @keypress.native.enter="handleLogin">
                                    <i slot="prefix" class="iconfont icon-icon_login_mima"></i>
                                    <i slot="suffix" class="iconfont"
                                    :class="passwordType ? 'icon-xianshimima' : 'icon-yincangmima'"
                                    @click="handleType"></i>
                                    </el-input>
                                </el-form-item>
                                <el-button :loading="loading" type="primary" @click.native.prevent="handleLogin">登录</el-button>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="live-summary">
            <div class="live-summary-title">直播内容介绍</div>
            <div class="live-summary-content">{{channelInfo.intro}}</div>
        </div>
    </div>
</template>

<script>
import watchApi from '@/api/watch'
import { accountLogin } from '@/api/launch/index'
import { setAccountId } from '@/utils/auth'

export default {
    name: 'launchLogin',
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入账号'))
            } else {
                callback()
            }
        }
        const validatePassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入密码'))
            } else {
                callback()
            }
        }
        return {
            loginForm: {
                username: '',
                password: ''
            },
            passwordType: false,
            loginRules: {
                username: [
                    { required: true, trigger: 'blur', validator: validateUsername }
                ],
                password: [
                    { required: true, trigger: 'blur', validator: validatePassword }
                ]
            },
            loading: false,
            channelInfo: {},
            channelId: ''
        }
    },
    created() {
        this.channelId = this.$route.query.channel_id
        this.getChannelDetail()
    },
    methods: {
        getChannelDetail() {
            watchApi.getChannelDetail(this.channelId, { role: 'teacher' }).then(res => {
                if (res.code === 0) {
                    this.channelInfo = res.data
                }
            }).catch(res => {})
        },
        handleLogin() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    accountLogin(this.channelId, this.loginForm).then(res => {
                        if (res.code === 0) {
                            const data = res.data
                            const sessionId = data.session_id
                            setAccountId(sessionId)
                            this.$router.push({ path: '/infor', query: { channel_id: this.channelId } })
                        }
                        this.loading = false
                    }).catch(res => {
                        this.loading = false
                    })
                } else {
                    return false
                }
            })
        },
        handleType() {
            this.passwordType = !this.passwordType
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
  .login-container {
    width: 100%;
    height: 100%;
    background: #F7F8FA;
    .login-top{
      width: 100%;
      height: 597px;
      overflow: hidden;
      margin-bottom: 24px;
      .login-top-bg{
        width: 100%;
        height: 100%;
        padding-top: 80px;
        background: url('https://chuangpei-prod.oss-cn-hangzhou.aliyuncs.com/images/bg_login.png') no-repeat top left;
        .login-top-content{
          width: 1200px;
          margin: 0 auto;
          .live-name{
            font-size: 24px;
            color: #fff;
            line-height: 24px;
            margin-bottom: 16px;
            font-weight: bold;
          }
          .live-time{
            font-size: 14px;
            color: #fff;
            line-height: 14px;
            margin-bottom: 16px;
          }
          .login-main {
            .live-img {
              float: left;
              width: 680px;
              height: 383px;
              border-radius: 8px 8px 0px 0px;
              margin-right: 24px;
              .live-img-src {
                display: block;
                width: 100%;
                height: 100%;
                border-radius: 8px 8px 0px 0px;
              }
            }
            .login-entrance {
              float: left;
              width: 496px;
              height: 383px;
              background: #FFFFFF linear-gradient(180deg, #DAEAFF 0%, #FFFFFF 30%);
              box-shadow: 0px 14px 40px 0px rgba(0, 95, 255, 0.64);
              border-radius: 8px;
              padding: 48px;
              box-sizing: border-box;
              .login-entrance-title {
                font-size: 28px;
                font-weight: bold;
                color: #171717;
                line-height: 24px;
                margin-bottom: 48px;
                text-align: center;
              }

              ::v-deep .el-form {
                .el-form-item {
                  margin-bottom: 24px;
                  .el-form-item__label {
                    font-size: 16px;
                    font-weight: 500;
                    color: #171717;
                    &:before {
                      display: none;
                    }
                  }

                  .el-input--prefix{
                    .el-input__inner{
                      padding-left: 40px;
                    }
                    .el-input__prefix{
                      left: 12px;
                      top: 3px;
                      .iconfont{
                        color: #A3A4B3;
                      }
                    }
                    .el-input__suffix{
                      right: 12px;
                      top: 3px;
                      cursor: pointer;
                      .iconfont{
                        color: #A3A4B3;
                        font-size: 24px;
                      }
                      &:hover{
                          .iconfont{
                            color: $primaryColor;
                        }
                      }
                    }
                  }
                  .el-input {
                    input:-webkit-autofill {
                      -webkit-box-shadow: 0 0 0 1000px white inset; /**通过边框阴影遮挡住背景*/
                      -webkit-text-fill-color: #333;
                    }
                    .el-input__inner {
                      border-radius: 4px;
                      height: 48px;
                      &::placeholder {
                        color: #909399;
                      }
                    }
                  }

                  &.is-error {
                    .el-input {
                      .el-input__inner {
                        border-color: #E94D41;
                      }
                    }
                  }
                }

                .el-button {
                  width: 100%;
                  height: 48px;
                  margin-top: 10px;
                  background: #1678FF;
                  border-radius: 4px;
                  font-size: 16px;
                  color: #fff;
                  letter-spacing: 4px;

                  .el-icon-loading {
                    font-size: 16px;
                  }

                  &:hover {
                    opacity: 0.75;
                  }
                }
              }
            }
          }
        }
      }
    }
    .live-summary{
      width: 1200px;
      margin: 0 auto;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 32px;
      box-sizing: border-box;
      .live-summary-title{
        font-size: 18px;
        line-height: 18px;
        color: #333333;
        font-weight: 500;
        padding-left: 12px;
        border-left: 3px solid #1678FF;
        margin-bottom: 24px;
      }
      .live-summary-content{
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 26px;
      }
    }
  }
</style>
